export default __webpack_public_path__ + "static/media/menu-bg@3x.aa29621b.png";